import { useSearchSuggestionsQuery } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsQuery";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useMemo } from "react";

//This is used for logged out discover and search pages
export const useLoggedOutSearchTopSearchPlaceholder = (
  query: string | undefined
) => {
  const { strictLocalize } = useStrictLocalization();
  const { data, isPending } = useSearchSuggestionsQuery(query, {
    enabled: !!query,
  });
  const placeholder = useMemo(() => {
    const firstSuggestedQuery = (
      data?.suggested_search_queries_display_order ?? []
    ).find((suggestedQuery) => suggestedQuery !== query);

    if (isPending) {
      return undefined;
    }

    if (firstSuggestedQuery) {
      return strictLocalize(
        {
          defaultMessage: "Search for “{searchProductName}”",
          description: {
            text: "Suggested search term for the search bar",
          },
        },
        {
          searchProductName: firstSuggestedQuery,
        }
      );
    } else {
      return strictLocalize({
        defaultMessage: "Search wholesale products or brands",
        description: {
          text: "Text for search box.",
        },
      });
    }
  }, [
    data?.suggested_search_queries_display_order,
    isPending,
    query,
    strictLocalize,
  ]);

  return placeholder;
};
